module.exports = __webpack_public_path__ + "resources/icon_32_alert_error.08b71abce78cc57a.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_32_alert_error.png
// module id = 450
// module chunks = 0 1 2 3 4